<template>
  <v-layout 
    short-control-toolbar
    hvf-toolbar
    align-center
    pa-0
    class="secondary">
    <v-flex escalon-col1>
      <v-btn text @click="closeHVFMultiview">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../../assets/' + coloredAssetUrls.returnToSingleView)">
        </v-avatar>Single View
      </v-btn>
    </v-flex>
    <v-flex escalon-col9>
      <v-layout>
        <v-flex eye-text escalon-alignCenter>
          <span :class="colorClass">{{eyeOnLeft}}</span>
        </v-flex>
        <v-flex eye-text escalon-alignCenter>
          <span :class="colorClass">{{eyeOnRight}}</span>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "hvfMultiExamToolbar",
  computed: {
    ...mapGetters(["hvfOrder"]),
    eyeOnLeft(){
      return this.hvfOrder ? "OS" : "OD";
    },
    eyeOnRight(){
      return this.hvfOrder ? "OD" : "OS";
    }
  },
  methods: {
    ...mapActions(["closeHVFMultiview"])
  }
}
</script>